import { observer } from "mobx-react";
import { INextStep } from "../final-onboarding-screen"
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import "./final-onboarding-screen-step.scss";

interface IProps {
    step: INextStep;
}

const FinalOnboardingScreenStep: React.FC<IProps> = observer(({step}: IProps) => {
    return(
        <div className="final-onboarding-screen-step">
            <img src={step.imgSrc} alt={step.alt} />
            <FontHeading4 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{step.title}</FontHeading4>
            <FontBody1 color={FONT_COLOR.PRIMARY2}>{step.description}</FontBody1>
        </div>
    );
});

export default FinalOnboardingScreenStep;